export const es = {
    search : {
    placeholder: 'Buscar...'
},
    typetitle : {
    type: 'Tipos'
},
    pokecardname : {
    name: 'Nombre'
},
    pokecardevolutions : {
    evolutions: 'Evoluciones'
},
    pokecardmoves : {
    moves: 'Movimientos'
    },
};